module.exports = __webpack_public_path__ + "img/logo-ui.de9de3be.png";